import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import BlogCard from './BlogCard'; // Component for individual blog cards
import logoSrc from '../img/logo.png';
import ContactForm from '../ContactForm'; // Ensure this component has the `openForm` method.
import './Blog.css';

const BlogPage = () => {
  const navigate = useNavigate();
  const contactFormRef = useRef();
  const [blogs, setBlogs] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('All');

  useEffect(() => {
    fetch('https://apiqms.shigjeta.com/api/blogs')
      .then((response) => {
        if (!response.ok) {
          throw new Error('Failed to fetch blog data');
        }
        return response.text();
      })
      .then((text) => {
        const data = JSON.parse(text).map((blog) => ({
          ...blog,
          mainImage: blog.mainImage || '/default-image.png',
        }));
        setBlogs(data);
      })
      .catch((error) => {
        console.error('Error loading blog data:', error);
      });
  }, []);

  const filteredBlogs = selectedCategory === 'All'
    ? blogs
    : blogs.filter(blog => blog.category === selectedCategory);

  const handleCategoryClick = (category) => {
    setSelectedCategory(category);
  };

  const handleOpenContactForm = () => {
    if (contactFormRef.current) {
      contactFormRef.current.openForm();
    }
  };

  const handleBlogClick = (blog) => {
    navigate(`/blog/${blog.id}`);
  };
  

  return (
    <>
      <div className="banner-logo" id="sectionBanner1">
        {logoSrc && <img src={logoSrc} alt="Shigjeta Logo" />}
      </div>
      <section className="banner-section" id="sectionBanner">
        <div className="banner-container">
          <div className="banner-text"> 
            <h1 className="banner-title">the story lab, where ideas come to life.</h1>
            <p className="banner-description">
              Experiment with ideas, explore compelling narratives, and create stories that inspire change.
            </p>
            <a onClick={handleOpenContactForm} className="banner-button">
              Start Now
            </a>
          </div>
          <div className="shop-hero-background"></div>
        </div>
      </section>
      <div className='img-background'>
        <img
          className="img"
          id='banner1-video'
          src="/img/Blogs Thumbnail.png"
          alt="Blog Thumbnail"
        />
      </div>
      
      <section className="shop-products" id="blogs">
        <div className="shop-header">
          <h1>Our Exclusive Blogs</h1>
          <p>Browse through our premium selection of blogs curated just for you.</p>
        </div>

        <div className="shop-category-filter">
          <h3>Select Your Category</h3>
          <p className="category-intro-text">
            Choose your preferred category to explore our unique collection of blogs.
          </p>
          <ul className="category-list">
            {['All', 'HowTo', 'Research', 'Stories Behind Our Journey'].map((category) => (
              <li key={category}>
                <a
                  href="#!"
                  className={`category-item ${selectedCategory === category ? 'active' : ''}`}
                  onClick={() => handleCategoryClick(category)}
                >
                  {category}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="shop-product-list">
          {filteredBlogs.length > 0 ? (
            filteredBlogs.map((blog) => (
              <BlogCard
                key={blog.id}
                product={blog}
                onClick={() => handleBlogClick(blog)}
              />
            ))
          ) : (
            <p>No blogs found in this category.</p>
          )}
        </div>
      </section>

      <section className="shop-cta">
        <div className="shop-cta-container">
          <p className="shop-cta-text">
            Found something you like? Stay connected for more updates and stories.
          </p>
        </div>
      </section>
      <ContactForm ref={contactFormRef} />
    </>
  );
};

export default BlogPage;
